import React from 'react';

type ChartTooltipProps = {
  xLabel: string;
  xValue: React.ReactNode;
  yLabel: string;
  yValue: React.ReactNode;
  color?: string;
};

/**
 * Shared hover tooltip for Custom Analytics line/bar charts.
 * Nivo's default line tooltip hardcodes "x" / "y" labels; we use the chart's axis legends instead.
 */
export default function ChartTooltip({ xLabel, xValue, yLabel, yValue, color }: ChartTooltipProps) {
  return (
    <div className="custom-analytics-graph__tooltip" role="tooltip">
      {color != null && <span className="custom-analytics-graph__tooltip-chip" style={{ background: color }} />}
      <div className="custom-analytics-graph__tooltip-rows">
        <div>
          {xLabel}: <strong>{xValue}</strong>
        </div>
        <div>
          {yLabel}: <strong>{yValue}</strong>
        </div>
      </div>
    </div>
  );
}
